import React from 'react';
import { Color } from 'csstype';
import * as R from 'ramda';

import DieFaceDisplay from './DieFaceDisplay';

type Props = {
  dieResults: number[][];
  colour: Color;
  title: string;
};

let index = 0;

/**
 * One row of individual die results
 * @param props
 */
const DiceDisplayRow: React.FC<Props> = (props) => (
  <div className="row">
    <p className="dice-display__row__title">{props.title}</p>
    <div className="dice-display__row">
      {R.pipe(
        R.map((result: number[]) => (
          <DieFaceDisplay value={result} key={index++} />
        )),
      )(props.dieResults)}
    </div>
  </div>
);

export default DiceDisplayRow;
